import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";
import { connect } from "formik";
import { Box, Button, Flex, Text } from "rebass";
import { MdClose, MdFullscreen } from "react-icons/all";
import { toastr } from "react-redux-toastr";

import { showModal } from "../../../store/modules/modal/actions";

import { Scrollbar } from "../../components/Scrollbar";

type IValues = {
  files: Array<File>;
}

const MAX = 2;
const LINE_HEIGHT = 55;

const buttonProps = {
  type: "button",
  ml: ["5px"],
  px: 0,
  py: 0,
  bg: "transparent",
  color: ["zodiac"],
};

export const FileList = connect<{}, IValues>(
  function FileList({ formik: { values, isSubmitting, setFieldValue } }) {
    const dispatch = useDispatch();
    const { files } = values;

    const removeFile = useCallback(
      (event: React.MouseEvent<Element & { value: string; }>) => {
        const { currentTarget: { value } } = event;

        setFieldValue("files", files.filter(({ name }: File) => name !== value));
      },
      [files, setFieldValue]
    );

    const showImage = useCallback(
      (event: React.MouseEvent<Element & { value: string; }>) => {
        const { currentTarget: { value } } = event;
        const file = files.find(({ name }) => name === value);

        if (file) {
          dispatch(showModal("showFile", { file }));
        } else {
          toastr.error("SHOW FILE", `file with name ${value} not exist.`);
        }
      },
      [files, dispatch]
    );

    const height = useMemo(
      () => `${LINE_HEIGHT * Math.min(files.length, MAX)}px`,
      [files]
    );

    return files.length > 0
      ? (
        <Box
          mt="1px"
          backgroundColor="#fff"
        >
          <Scrollbar style={{ height }}>
            <Box as="ul" pl={0}>
              {
                files.map(({ name }) => (
                  <Flex
                    as="li"
                    key={name}
                    alignItems="center"
                    px="18px"
                    py="14.5px"
                    color="zodiac"
                  >
                    <Text
                      flex={1}
                      css="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                    >
                      {name}
                    </Text>

                    <Button
                      {...buttonProps}
                      value={name}
                      onClick={showImage}
                      disabled={isSubmitting}
                    >
                      <MdFullscreen display="block" size={26} />
                    </Button>

                    <Button
                      {...buttonProps}
                      value={name}
                      onClick={removeFile}
                      disabled={isSubmitting}
                    >
                      <MdClose display="block" size={26} />
                    </Button>
                  </Flex>
                ))
              }
            </Box>
          </Scrollbar>
        </Box>
      )
      : null;
  }
);
